import { useMemo } from 'react';

import type { ActionResolution } from 'modules/common/components/findings';
import type { ISuggestionAnnotation } from 'modules/common/viewer/pdfViewer/annotationCommands/SuggestionAnnotation';

import {
  DEFAULT_GEOMETRIC_ACTIONS,
  useGeometricActionData,
  type GeometricAnnotationActions,
} from './GeometricActionsDataContext';

const noOpActions = DEFAULT_GEOMETRIC_ACTIONS();

export const useGeometricActions = (
  annotation: ISuggestionAnnotation | null,
): ActionResolution<{ geometricActions: GeometricAnnotationActions }> => {
  const { processAnnotation, geometricActions } = useGeometricActionData();

  const payload = useMemo(
    () => processAnnotation(annotation),
    [processAnnotation, annotation],
  );
  const geometricActionsFn = useMemo(
    () => (payload ? geometricActions(payload) : noOpActions),
    [payload, geometricActions],
  );
  if (!payload) {
    return { enabled: false, geometricActions: geometricActionsFn };
  }

  return {
    enabled: true,
    geometricActions: geometricActionsFn,
  };
};
